export const ModuleMigrateStatus = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
  Skipped: 'Skipped',
} as const;

export type ModuleMigrateStatus = (typeof ModuleMigrateStatus)[keyof typeof ModuleMigrateStatus];

export const UserMigrationStatus = {
  NotConfigured: 'NotConfigured',
  Disabled: 'Disabled',
  Pending: 'Pending',
  InProgress: 'InProgress',
  Succeeded: 'Succeeded',
  Partial: 'Partial',
  Failed: 'Failed',
  Skipped: 'Skipped',
} as const;

export type UserMigrationStatus = (typeof UserMigrationStatus)[keyof typeof UserMigrationStatus];

export const AmplifyProvisioningStatus = {
  NotApplicable: 'NotApplicable',
  Pending: 'Pending',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
} as const;

export type AmplifyProvisioningStatus =
  (typeof AmplifyProvisioningStatus)[keyof typeof AmplifyProvisioningStatus];

// Third post-migration status axis — meaningful for any module (sync or async-polled)
// that configures MetadataUpdates bindings; stays NotApplicable otherwise.
export const AmplifyMetadataUpdateStatus = {
  NotApplicable: 'NotApplicable',
  Pending: 'Pending',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
} as const;

export type AmplifyMetadataUpdateStatus =
  (typeof AmplifyMetadataUpdateStatus)[keyof typeof AmplifyMetadataUpdateStatus];

export const ModuleExecutionMode = {
  Synchronous: 'Synchronous',
  AsyncPolled: 'AsyncPolled',
} as const;

export type ModuleExecutionMode =
  (typeof ModuleExecutionMode)[keyof typeof ModuleExecutionMode];

export interface MigrationModule {
  id: string;
  moduleKey: string;
  sourceId: string;
  amplifyModuleId: number;
  bridgeProductId: string | null;
  configurationOverridesJson: string | null;
  migrateStatus: ModuleMigrateStatus;
  migrateError: string | null;
  migrateStartedAt: string | null;
  migrateCompletedAt: string | null;
  retryCount: number;
  userMigrationStatus: UserMigrationStatus;
  userMigrationTotalUsers: number;
  userMigrationUuidsSent: number;
  userMigrationUuidsFailed: number;
  amplifyProvisioningStatus: AmplifyProvisioningStatus;
  // Metadata-update axis (any execution mode) + async-polled job tracking
  amplifyMetadataUpdateStatus: AmplifyMetadataUpdateStatus;
  amplifyMetadataUpdateError: string | null;
  migrationJobId: string | null;
  migrationJobPollAttempts: number;
}

// Matches backend ModuleConfigurationDto (camelCase)
export interface ModuleConfiguration {
  id: string;
  moduleKey: string;
  displayName: string;
  description: string | null;
  isEnabled: boolean;
  displayOrder: number;
  sourceIdValidationRegex: string | null;
  sourceIdPlaceholder: string | null;
  migrateEndpoint: string | null;
  validateEndpoint: string | null;
  timeoutSeconds: number;
  maxRetries: number;
  retryDelaySeconds: number;
  metaFields: string | null;
  amplifyModuleId: number | null;
}

export const MODULE_KEYS = {
  Giving: 'giving',
  People: 'people',
  ServicePlanning: 'serviceplanning',
} as const;

export type ModuleKey = (typeof MODULE_KEYS)[keyof typeof MODULE_KEYS];
